import { useTranslation } from "react-i18next";
import { GeneralButton } from "../../components";
import { useNavigate } from "react-router-dom";
function NotFound() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-neutral-50 px-4 text-center">
      <h1 className="text-[120px] font-extrabold leading-none tracking-tight max-sm:text-[75px] md:text-[160px]">
        404
      </h1>
      <h2 className="mt-4 text-2xl font-semibold text-neutral-800 md:text-3xl">
        {t("page_not_found")}
      </h2>
      <p className="mt-3 max-w-md leading-relaxed text-neutral-500">
        {t("page_not_found_message")}
      </p>
      <GeneralButton
        onClick={() => navigate("/")}
        className="mt-8 rounded-xl px-6 py-2.5"
        title={t("go_home")}
      />
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
        <span className="text-body-text select-none text-[300px] font-black opacity-20 max-sm:text-[150px]">
          404
        </span>
      </div>
    </div>
  );
}
export default NotFound;
